"use strict";

export default angular.module("Authorization", [])
.provider('principal', function() {

    let application = "app", httpParams = {};

    this.setApplication = (app, hParams) => {
        application = app;
        angular.extend(httpParams, hParams);
    };

    this.$get = ($q, $http, $httpOnce) => {
        var _identity = undefined,
            _authenticated = false;

        return {
            application,
            isIdentityResolved () {
                return angular.isDefined(_identity);
            },
            isAuthenticated () {
                return _authenticated;
            },
            isInRole: function (role) {
                if (!_authenticated || !_identity.roles) return false;
                return _identity.roles.indexOf(role) != -1;
            },
            isInAnyRole: function (roles) {
                if (!_authenticated || !_identity.roles) return false;
                for (var i = 0; i < roles.length; i++) {
                    if (this.isInRole(roles[i])) return true;
                }
                return false;
            },
            _identity() {
                return _identity;
            },
            authenticate (identity) {
                _identity = identity;
                _authenticated = identity != null;
            },
            identity (force) {
                let deferred = $q.defer();

                if (force === true) _identity = undefined;

                // check and see if we have retrieved the identity data from the server. if we have, reuse it by immediately resolving
                if (angular.isDefined(_identity)) {
                    deferred.resolve(_identity);

                    return deferred.promise;
                }

                //otherwise, retrieve the identity data from the server, update the identity object, and then resolve.

                const httpBody = {
                    method: "POST",
                    data: httpParams,
                    headers: { "Content-Type": "application/json; charset=utf-8" }
                };
                let roles = [];

                switch (application) {
                    case "invitados":
                        httpBody.url = "../../../servicios/PortalServicio.svc/ObtenerClienteInvitadoNombre";
                        roles = ['invitados'];
                        break;
                    default:
                        httpBody.url = "../../../servicios/PortalServicio.svc/LlenarDatosPantalla";
                        break;
                }

                let httpService = force ? $http : $httpOnce;

                httpService(httpBody).then(({ data }) => {
              
                    if (data.Respuesta && data.CodigoRespuesta == 200) {                       

                        if (angular.isArray(data.Respuesta.Permisos)) {
                            roles = data.Respuesta.Permisos.map(p => p.TipoPermiso);
                        }

                        _identity = {
                            roles: roles,
                            userInfo: data.Respuesta
                        };
                        _authenticated = true;
                        deferred.resolve(_identity);
                    } else {
                        _identity = null;
                        _authenticated = false;
                        deferred.resolve(_identity);
                    }
                },
                    (error) => {
                        _identity = null;
                        _authenticated = false;
                        deferred.resolve(_identity);
                    }
                );

                return deferred.promise;
            }
        };
    };

})
// authorization service's purpose is to wrap up authorize functionality
// it basically just checks to see if the principal is authenticated and checks the root state 
// to see if there is a state that needs to be authorized. if so, it does a role check.
// this is used by the state resolver to make sure when you refresh, hard navigate, or drop onto a
// route, the app resolves your identity before it does an authorize check. after that,
// authorize is called from $stateChangeStart to make sure the principal is allowed to change to
// the desired state
    .factory('authorization', ($rootScope, $stateParams, $state, $window, $q, principal) => {

      const redirect = () => {
          switch (principal.application) {
              case "invitados":
                  $state.go('login.sesion');
                  break;
              default:
                  $window.open('/Login', '_self');
                  break;
          }
      }

      return {
          authorize(force) {

              let isIdentityResolved = principal.isIdentityResolved(),
                  _identity = principal._identity(),
                  currentUser = (_identity && _identity.userInfo && _identity.userInfo.UsuarioInfo) ? _identity.userInfo.UsuarioInfo.ClaveContribuyente : 0;

              return principal.identity(force)
                  .then((data) => {

                      let isAuthenticated = principal.isAuthenticated(),
                          isIdentityResolved = principal.isIdentityResolved();

                      if ($rootScope.toState && $rootScope.toState.data && $rootScope.toState.data.roles
                          && $rootScope.toState.data.roles.length > 0 && !principal.isInAnyRole($rootScope.toState.data.roles)) {

                          if (!isAuthenticated) {
                              // user is not authenticated. stow the state they wanted before you
                              // send them to the signin state, so you can return them when you're done
                              $rootScope.returnToState = $rootScope.toState;
                              $rootScope.returnToStateParams = $rootScope.toStateParams;
                              // now, send them to the signin state so they can log in                            
                          }
                          redirect();
                          return $q.reject(403);
                      }

                      if (isIdentityResolved && isAuthenticated) {                      
                        if (currentUser == 0 || (
                            data.userInfo.UsuarioInfo && data.userInfo.UsuarioInfo.ClaveContribuyente && data.userInfo.UsuarioInfo.ClaveContribuyente != currentUser)) {          
                              $rootScope.$broadcast("UserInfoUpdated", data.userInfo);
                          }                          
                          return $q.resolve(data.userInfo);
                      } else {
                          redirect();
                      }

                  });
          }
      };
  }
);
